<template>
    <div class="tab-my-track">
        <template v-if="!isMobile">
            <MyTimeline class="tab-my-track__timeline" :items="myCurrentItems" :isLoading="isLoading" />
            <Join class="tab-my-track__join" :items="myCurrentItems" />
        </template>
        <template v-else>
            <Tabs :activeField="tabActiveField" isBgMode :slotsHeaders="tabs" @change-field="setField" :stub="false">
                <template #MyTimelineTab>
                    <ListTimeline class="tab-my-track__list-timeline" :items="myCurrentItems" :isLoading="isLoading" />
                </template>
                <template #JoinTab>
                    <Join class="tab-my-track__join" :items="myCurrentItems" />
                </template>
            </Tabs>
        </template>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import 'moment-duration-format';
import 'moment/locale/ru';
import MyTimeline from '@/views/track/components/timeline/MyTimeline.vue';
import ListTimeline from '@/views/track/components/timeline/ListTimeline.vue';

import Join from '@/views/track/components/join/Join.vue';
import Tabs from '@/components/UI/Tabs';

export default {
    name: 'TabMyTrack',
    components: {
        MyTimeline,
        ListTimeline,
        Join,
        Tabs,
    },
    created() {
        moment.locale('ru');
    },
    data() {
        return {
            isLoading: true,
            myCurrentItems: [],
            tabActiveField: 0,
            tabs: [
                {
                    name: 'MyTimelineTab',
                    title: 'Мой трек',
                },
                {
                    name: 'JoinTab',
                    title: 'Начни сегодня',
                },
            ],
        };
    },
    computed: {
        ...mapGetters(['isMobile']),
        ...mapGetters('competitions', ['getInvolvedProjectsSPK2']),
    },
    methods: {
        ...mapActions('competitions', ['loadInvolvedProjectsSPK2']),
        ...mapActions('internship', ['loadMyInternship']),
        ...mapActions('events', ['loadAllCourses']),
        ...mapActions('track', ['fetchMyActivity']),
        calculateEndDate(dateStart, duration) {
            const start = moment(dateStart);
            const durationObj = moment.duration(duration);
            return start.clone().add(durationObj).format();
        },
        setField(index) {
            this.tabActiveField = index;
        },
    },
    async mounted() {
        const promises = [
            this.loadInvolvedProjectsSPK2(),
            this.loadMyInternship({ completed: undefined }),
            this.loadAllCourses(),
        ];
        await Promise.all(promises).then(([projects, internship, courses]) => {
            this.myCurrentItems = [];

            projects.data.forEach((item) => {
                this.myCurrentItems.push({
                    type: 'project',
                    id: item.id,
                    name: item.name,
                    dateStart: item.dateStart,
                    dateEnd: item.dateEnd || null,
                });
            });

            internship.data.forEach((item) => {
                this.myCurrentItems.push({
                    type: 'internship',
                    id: item.id,
                    name: item.name,
                    dateStart: item.dateStart,
                    dateEnd: item.dateEnd || null,
                });
            });

            courses.events.forEach((item) => {
                this.myCurrentItems.push({
                    type: 'event',
                    id: item.id,
                    name: item.name,
                    eventSiteUrl: item.eventSiteUrl,
                    dateStart: item.participantStartDate,
                    dateEnd:
                        item.participantEndDate ||
                        this.calculateEndDate(item.participantStartDate, item.durationInterval),
                });
            });

            this.fetchMyActivity(this.myCurrentItems);
        });
        this.isLoading = false;
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/variables';

.tab-my-track {
    padding: urem(20);
    display: flex;
    align-items: flex-start;
    gap: urem(30);

    @include on-desktop {
        padding: urem(40);
    }

    &__timeline {
        width: urem(1083);
    }

    :deep(.tabs-wrapper) {
        width: 100%;
    }

    :deep(.tabs) {
        margin-bottom: urem(20);

        .tab {
            font-size: urem(14);
        }
        .active {
            color: rgba(70, 99, 171, 1);
            font-size: urem(14);
            font-weight: 500;
        }
    }
}
</style>
